<article id="manage-page">
  <swoosh [text]="swooshText" [external]="swooshExternal"></swoosh>
  <div class="container-fluid header">
    <div class="container manage-intro-copy" [innerHtml]="introduction | safeHtml"></div>
  </div>
  <div class="purple-swoosh"></div>

  <div class="container padding">
    <div class="row">
      <div class="col-md-12 intro-title">Team Members</div>
    </div>
    <div class="row">
      <div class="col-md-4">
        <div class="input-group my-3">
          <span class="input-group-text" id="teamSearchIcon"></span>
          <input
            id="teamSearch"
            name="teamSearch"
            type="text"
            class="form-control"
            (input)="onTeamSearch($event)"
            placeholder="Search members"
            aria-label="Search members"
            aria-describedby="teamSearchIcon"
          />
        </div>
      </div>
      <div class="col-md-8 text-md-end completed-count">{{ completed }}/{{ rowData.length }} Team members completed their assessments</div>
    </div>
    <div class="row" *ngIf="completed != rowData.length">
      <div class="col-md-4">
        <div class="d-none d-md-block">
          <button class="btn-primary mt-0" (click)="showReminderModal(emailReminderModal)" [disabled]="disableSendReminderButton">
            Send Reminder
          </button>
        </div>
        <div class="d-block d-md-none pad-bottom-md">
          <a (click)="showReminderModal(emailReminderModal)" [ngClass]="{ disabled: noneSelected }">Send Reminder</a>
        </div>
      </div>
      <div class="col-md-8 order-first order-md-2 text-md-end intro-copy">
        The team will access Team Type and additional
        <div class="clearfix d-none d-md-block"></div>
        insights only when all team members are done!
      </div>
    </div>

    <ag-grid-angular
      #agGrid
      class="ag-theme-alpine manage-team-grid"
      [gridOptions]="gridOptions"
      [domLayout]="'autoHeight'"
      [theme]="'legacy'"
      [loading]="false"
      [rowData]="rowData"
      [columnDefs]="columDefinitions"
      [components]="frameworkComponents"
      [defaultColDef]="defaultColDef"
      [rowSelection]="rowSelection"
      [pagination]="true"
      [paginationPageSize]="paginationPageSize"
      [suppressPaginationPanel]="true"
      (paginationChanged)="onPaginationChanged()"
      (gridReady)="onGridReady($event)"
      (rowSelected)="onRowSelected()"
    >
    </ag-grid-angular>
    <div class="grid-footer" *ngIf="rowData.length > 10" [hidden]="isMobile">
      <div>
        {{ displayStart }} - {{ displayEnd }} of {{ numTeamMembers }} MEMBERS / ROWS PER PAGE
        <select name="rowsPerPage" id="rowsPerPage" (change)="changePagination($event)" class="dropdown">
          <option value="5">5</option>
          <option value="10" selected>10</option>
          <option value="25">25</option>
          <option value="50">50</option>
        </select>
      </div>
      <div class="center">
        GO TO PAGE
        <select name="goToPageDropdown" id="goToPageDropdown" (change)="goToPage($event)" class="dropdown">
          <option *ngFor="let item of [].constructor(numPages); let i = index" [ngValue]="i + 1">{{ i + 1 }}</option>
        </select>
        of {{ numPages }}
      </div>
      <div class="right">
        <span class="arrows">
          <a (click)="onBtFirst()" [ngClass]="arrowFirst">&#171;</a>
          <span class="arrow-spacer"></span>
          <a (click)="onBtPrevious()" [ngClass]="arrowPrevious">&#8249;</a>
          <span class="arrow-spacer"></span>
          <a (click)="onBtNext()" [ngClass]="arrowNext">&#8250;</a>
          <span class="arrow-spacer"></span>
          <a (click)="onBtLast()" [ngClass]="arrowLast">&#187;</a>
        </span>
      </div>
    </div>
    <div class="grid-footer mobile" *ngIf="rowData.length > 10" [hidden]="!isMobile">
      <div>
        {{ displayStart }} - {{ displayEnd }} of {{ numTeamMembers }} MEMBERS / ROWS PER PAGE
        <select name="rowsPerPageMobile" id="rowsPerPageMobile" (change)="changePagination($event)" class="dropdown">
          <option value="5">5</option>
          <option value="10" selected>10</option>
          <option value="25">25</option>
          <option value="50">50</option>
        </select>
      </div>
      <div>
        <span class="spacer"></span>
        <span class="arrows">
          <a (click)="onBtFirst()" [ngClass]="arrowFirst">&#171;</a>
          <span class="arrow-spacer"></span>
          <a (click)="onBtPrevious()" [ngClass]="arrowPrevious">&#8249;</a>
          <span class="arrow-spacer"></span>
          <a (click)="onBtNext()" [ngClass]="arrowNext">&#8250;</a>
          <span class="arrow-spacer"></span>
          <a (click)="onBtLast()" [ngClass]="arrowLast">&#187;</a>
        </span>
      </div>
    </div>

    <ng-template #contentCellMobile let-row>
      <div class="row-content">
        <div class="row-name">
          {{ row.id + 1 }}.
          <div *ngIf="row.isTeamLeader; then teamLeader; else notTeamLeader"></div>
          <ng-template #teamLeader>{{ row.fullName }} (You)</ng-template>
          <ng-template #notTeamLeader>{{ row.fullName }}</ng-template>
        </div>
        <div class="row-email">
          {{ row.emailAddress }}
        </div>
        <div class="row-access-code">
          {{ row.accessCode }}
        </div>
      </div>
    </ng-template>

    <ng-template #emailReminderModal let-modal>
      <div class="modal-header">
        <div class="modal-title">Email Remind</div>
        <img class="close-modal-image" src="/assets/images/close-static.svg" (click)="modal.dismiss()" />
      </div>
      <div class="modal-body">
        <div *ngIf="!reminderSent">Are you sure you want to send an email reminder to selected members of the team?</div>
        <div *ngIf="reminderSent" class="pad-bottom">
          <div [hidden]="hideReminderSpinner" class="spinner-container pad-bottom">
            <div class="d-flex justify-content-center">
              <div class="spinner-border custom-spinner" role="status">
                <span class="visually-hidden">Sending...</span>
              </div>
            </div>
          </div>
          <div [hidden]="!hideReminderSpinner" class="pad-bottom">
            {{ reminderResponse }}
          </div>
          <button class="btn-primary" (click)="modal.dismiss()">Close</button>
        </div>
      </div>
      <div class="modal-footer" *ngIf="!reminderSent">
        <button class="btn-primary" (click)="sendReminder()">Yes, Remind</button>
        <a (click)="modal.dismiss()">No, Cancel</a>
      </div>
    </ng-template>
  </div>
</article>
